export default __webpack_public_path__ + "static/media/what.d65fb1ce.png";